import { render } from "./PasswordResetForm.vue?vue&type=template&id=6d3ac692&ts=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=ts"
export * from "./PasswordResetForm.vue?vue&type=script&lang=ts"

import "./PasswordResetForm.vue?vue&type=style&index=0&id=6d3ac692&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__